export const sports = {
  BASKETBALL: "basketball",
  HANDBALL: "handball",
  HOCKEY: "hockey",
  ICE3: "ice3",
  VOLLEYBALL: "volleyball",
};
